export const SET_MANAGEMENT_CERTIFICATES_LIST = 'management/SET_MANAGEMENT_CERTIFICATES_LIST'
export const SET_MANAGEMENT_ENTREPRENEUR_PROFILES_LIST = 'management/SET_MANAGEMENT_ENTREPRENEUR_PROFILES_LIST'
export const SET_SURVEY_LIST = 'management/SET_SURVEY_LIST'
export const SET_MANAGEMENT_PROFILES_LIST = 'management/SET_MANAGEMENT_PROFILES_LIST'
export const SET_PARTNER_LIST = 'management/SET_PARTNER_LIST'
